module.exports = __webpack_public_path__ + "static/media/ongoing.5ee4e7e8.gif";